const SvgSzyba60 = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 60 60">
    <path fill="#373737" fillRule="evenodd" d="M15 2h30v56H15V2m2 2v52h26V4zm7 22.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M39 8H21v5h18zM21 39h18v5H21zm18-8H21v5h18zM21 47h18v5H21zm18-30H21v5h18z" clipRule="evenodd" />
  </svg>;
export default SvgSzyba60;